import { createModal } from '@codegouvfr/react-dsfr/Modal';
import { DsfrModal } from './types/dsfr-modal.type';

export function getModalById(id: string) {
  const modal: DsfrModal = createModal({ id, isOpenedByDefault: false }) as DsfrModal;
  modal.data ??= {};
  return modal;
}